import { userBaseUrl } from "@/api/system/user"
import { createFormItem } from "@/component-create/utils/create-form-item"
import { FormDialog } from "@/component-create/FormDialog"
import { FORM_ITEM } from "@/components/form/enums"

import RoleSelect from '@/views/components/RoleSelect.vue'
import DepartmentSelect from '@/views/components/DepartmentSelect.vue'
import { USERNAME } from "@/utils/pattern"

/**
 * 绘制新增表单
 */
 export function renderAddForm(el: Element) {
  const addForm = new FormDialog(
    el,
    {
      items: items,
      elFormProps: { rules: rules },
      saveUrl: userBaseUrl
    },
    '新增'
  )

  return addForm
}

const items = [
  [
    createFormItem('用户名', 'username', FORM_ITEM.INPUT, { clearable: true, maxlength: '100' }),
    createFormItem('密码', 'password', FORM_ITEM.INPUT, { clearable: true, maxlength: '20', showPassword: true })
  ],
  [
    createFormItem('昵称', 'nickname', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' }),
    createFormItem('性别', 'gender', FORM_ITEM.SELECT, { loader: 'USER_GENDER' }),
  ],
  [
    createFormItem('手机号码', 'phoneNumber', FORM_ITEM.INPUT, { clearable: true, maxlength: '11' }),
    createFormItem('邮箱地址', 'email', FORM_ITEM.INPUT, { clearable: true, maxlength: '50' }),
  ],
  [
    createFormItem('角色', 'roles', RoleSelect as VueComponent, { multiple: true }),
  ],
  [
    createFormItem('部门', 'departments', DepartmentSelect as VueComponent, { multiple: true }),
  ],
  [
    createFormItem('岗位', 'posts', FORM_ITEM.SELECT, { loader: 'ENABLE_POST', multiple: true  }),
  ],
  [
    createFormItem('状态', 'status', FORM_ITEM.SELECT, { loader: 'USER_STATUS', default: true, }),
    null
  ],
  [
    createFormItem('备注', 'remark', FORM_ITEM.INPUT, { type: 'textarea', rows: 3, maxlength: '200', showWordLimit: true }),
  ]
]

const rules = {
  username: [{ required: true, message: '请输入用户名', trigger: 'blur' },
    { min: 4, max: 100, message: '不能少于4个字符,不能超过100个字符', trigger: 'blur' },
    { required: true, message: '只能包含字母、数字、下划线', trigger: 'blur' }],
  nickname: [{ required: true, message: '请输入昵称', trigger: 'blur' },
    { min: 2, max: 20, message: '不能少于2个字符,不能超过20个字符', trigger: 'blur' }],
  password: [{ required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, max: 20, message: '不能少于6个字符,不能超过20个字符', trigger: 'blur' }],
  gender: [{ required: true, message: '请选择性别', trigger: 'blur' }],
  status: [{ required: true, message: '请选择状态', trigger: 'blur' }]
}
